class Tracking {
    constructor() {
        this.init();
    }

    init() {
        this.loadGclidPixel();
        this.appendParamsToLinks();
    }

    loadGclidPixel() {
        const urlParams = new URLSearchParams(window.location.search);
        const gclid = urlParams.get('gclid');

        if (gclid) {
            const r = btoa(window.location.href);
            const img = document.createElement('img');
            img.src = 'https://prod-api.n7e.app/subgraphs/gclid/pixel.gif?gclid=' + gclid + '&r=' + r;
            img.style.visibility = 'hidden';
            img.style.position = 'absolute';
            img.onload = img.remove;
            img.onerror = img.remove;
            document.body.appendChild(img);
        }
    }

    appendParamsToLinks() {
        const urlParams = new URLSearchParams(window.location.search);
        const path = window.location.pathname;

        const paramsToForward = [
            'gclid',
            'msclkid',
            'tw_source',
            'tw_adid',
            'tw_campaign'
        ];

        const hasTwParams = ['tw_source', 'tw_adid', 'tw_campaign'].some(param => urlParams.has(param));
        const hasUtmParams = ['utm_source', 'utm_content', 'utm_campaign'].some(param => urlParams.has(param));

        // Map UTM parameters to TW if needed
        if (!hasTwParams && hasUtmParams) {
            if (urlParams.has('utm_source')) {
                urlParams.set('tw_source', urlParams.get('utm_source'));
            }
            if (urlParams.has('utm_content')) {
                urlParams.set('tw_adid', urlParams.get('utm_content'));
            }
            if (urlParams.has('utm_campaign')) {
                urlParams.set('tw_campaign', urlParams.get('utm_campaign'));
            }
        }

        const countryCode = path.startsWith('/at') ? 'at' :
            path.startsWith('/ch') ? 'ch' : null;

        const hasParamsToForward = paramsToForward.some(param => urlParams.has(param));

        if (hasParamsToForward) {
            const links = document.querySelectorAll('.article-container a');

            links.forEach(link => {
                if (link.href && !link.href.startsWith('#') &&
                    (link.href.startsWith('http') || link.href.startsWith('https'))) {

                    try {
                        const href = new URL(link.href);

                        paramsToForward.forEach(param => {
                            const value = urlParams.get(param);
                            if (value) {
                                href.searchParams.set(param, value);
                            }
                        });

                        if (countryCode) {
                            href.searchParams.set('c', countryCode);
                        }

                        link.href = href.toString();
                    } catch (e) {
                        console.error('Error processing URL:', link.href, e);
                    }
                }
            });
        }
    }
}

window.addEventListener('load', () => new Tracking());